/* Header CTA pill: swaps the "Try the cream" button for the basket-total
   pill when the basket gains items, and keeps the total in sync. The
   product template always shows the basket pill (data-always-cart). */
(() => {
  class HeaderCta extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }

    onCartUpdate(event) {
      const cart = event.cart;
      if (!cart || cart.errors) return;

      this.querySelectorAll('[data-cart-total]').forEach((total) => {
        total.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
      });

      if (!this.hasAttribute('data-always-cart')) {
        const cta = this.querySelector('[data-cta]');
        const pill = this.querySelector('[data-cart-pill]');
        const showCart = cart.item_count > 0;
        if (cta) cta.hidden = showCart;
        if (pill) pill.hidden = !showCart;
      }
    }
  }

  customElements.define('header-cta', HeaderCta);
})();
